import { EventId } from '../../../../../commonv3/types/events';
import { observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventShowView } from '../../../../types/events';
import { EventApis } from '../../../../apis/events';

export class ReservationCompletePaneState {
    @observable eventId: EventId = null;
    @observable event: RemoteResourceV3<EventShowView> = RemoteResourceV3.loading();

    async init(eventId: EventId) {
        this.eventId = eventId;
        await this.reloadEvent();
    }

    async reloadEvent() {
        await updateRemoteResourceV3(this.event, (v) => (this.event = v), () => EventApis.find(this.eventId));
    }
}
